export default __webpack_public_path__ + "static/media/worker.b92e472d.png";